export interface ParticipanteCampanha {
  id: string;
  nome: string;
  email: string;
  cpf: string;
  status: 'ativo' | 'pendente' | 'bloqueado';
  pontosDisponiveis: number;
  pontosAcumulados: number;
  nivel: number;
  ultimoResgate?: string;
  campanhaId: string;
  empresaId: string;
  configPersonalizada: boolean;
  // Campos que podem ser customizados individualmente
  limiteResgateDiarioPersonalizado?: number;
  limiteResgateMensalPersonalizado?: number;
  taxaProcessamentoPixPersonalizada?: number;
  prazoAprovacaoSaquePersonalizado?: number;
}

export const participantesCampanhas: ParticipanteCampanha[] = [
  // CAMP-001 (getPoints) - Vendas Q1 2026
  {
    id: 'PART-C1-001',
    nome: 'João Pedro Silva',
    email: 'joao.silva@email.com',
    cpf: '123.456.789-00',
    status: 'ativo',
    pontosDisponiveis: 4520,
    pontosAcumulados: 12800,
    nivel: 5,
    ultimoResgate: '2026-05-05',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    configPersonalizada: false,
  },
  {
    id: 'PART-C1-002',
    nome: 'Maria Fernanda Costa',
    email: 'maria.costa@email.com',
    cpf: '987.654.321-00',
    status: 'ativo',
    pontosDisponiveis: 8900,
    pontosAcumulados: 24500,
    nivel: 8,
    ultimoResgate: '2026-05-07',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    configPersonalizada: true,
    limiteResgateDiarioPersonalizado: 5000,
    limiteResgateMensalPersonalizado: 20000,
    taxaProcessamentoPixPersonalizada: 1.0,
  },
  {
    id: 'PART-C1-003',
    nome: 'Carlos Eduardo Mendes',
    email: 'carlos.mendes@email.com',
    cpf: '456.789.123-00',
    status: 'ativo',
    pontosDisponiveis: 3200,
    pontosAcumulados: 9800,
    nivel: 4,
    ultimoResgate: '2026-05-03',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    configPersonalizada: false,
  },
  {
    id: 'PART-C1-004',
    nome: 'Ana Paula Ribeiro',
    email: 'ana.ribeiro@email.com',
    cpf: '789.123.456-00',
    status: 'ativo',
    pontosDisponiveis: 6700,
    pontosAcumulados: 18600,
    nivel: 6,
    ultimoResgate: '2026-04-28',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    configPersonalizada: true,
    limiteResgateDiarioPersonalizado: 3000,
    prazoAprovacaoSaquePersonalizado: 12,
  },
  {
    id: 'PART-C1-005',
    nome: 'Pedro Henrique Lima',
    email: 'roberto.dias@email.com',
    cpf: '321.654.987-00',
    status: 'pendente',
    pontosDisponiveis: 0,
    pontosAcumulados: 0,
    nivel: 1,
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    configPersonalizada: false,
  },
  // CAMP-002 (getPoints) - Performance Abril
  {
    id: 'PART-C2-001',
    nome: 'Roberta Santos',
    email: 'bia.santos@email.com',
    cpf: '654.987.321-00',
    status: 'ativo',
    pontosDisponiveis: 2100,
    pontosAcumulados: 5400,
    nivel: 3,
    ultimoResgate: '2026-04-20',
    campanhaId: 'CAMP-002',
    empresaId: 'EMP-001',
    configPersonalizada: false,
  },
  {
    id: 'PART-C2-002',
    nome: 'Felipe Andrade',
    email: 'amanda@consultoratech.com.br',
    cpf: '147.258.369-00',
    status: 'ativo',
    pontosDisponiveis: 4300,
    pontosAcumulados: 11200,
    nivel: 5,
    campanhaId: 'CAMP-002',
    empresaId: 'EMP-001',
    configPersonalizada: true,
    limiteResgateDiarioPersonalizado: 4000,
    taxaProcessamentoPixPersonalizada: 0.5,
  },
  // CAMP-003 (Inova Digital) - Captação de Clientes
  {
    id: 'PART-C3-001',
    nome: 'Luciana Torres',
    email: 'ricardo@inovacaodigital.com.br',
    cpf: '258.369.147-00',
    status: 'ativo',
    pontosDisponiveis: 1500,
    pontosAcumulados: 4200,
    nivel: 2,
    campanhaId: 'CAMP-003',
    empresaId: 'EMP-002',
    configPersonalizada: false,
  },
  {
    id: 'PART-C3-002',
    nome: 'Bruno Oliveira',
    email: 'fernanda@techbrasil.com.br',
    cpf: '369.147.258-00',
    status: 'ativo',
    pontosDisponiveis: 3800,
    pontosAcumulados: 9800,
    nivel: 4,
    ultimoResgate: '2026-05-06',
    campanhaId: 'CAMP-003',
    empresaId: 'EMP-002',
    configPersonalizada: true,
    limiteResgateDiarioPersonalizado: 2500,
    limiteResgateMensalPersonalizado: 10000,
  },
  {
    id: 'PART-C3-003',
    nome: 'Camila Ferreira',
    email: 'luciana@empresaexemplo.com.br',
    cpf: '741.852.963-00',
    status: 'bloqueado',
    pontosDisponiveis: 0,
    pontosAcumulados: 1500,
    nivel: 2,
    campanhaId: 'CAMP-003',
    empresaId: 'EMP-002',
    configPersonalizada: false,
  },
  // CAMP-004 (TechBrasil) - Capacitação Q2
  {
    id: 'PART-C4-001',
    nome: 'Daniel Souza',
    email: 'paulo@sistemasintegrados.com.br',
    cpf: '852.963.741-00',
    status: 'ativo',
    pontosDisponiveis: 800,
    pontosAcumulados: 2100,
    nivel: 2,
    campanhaId: 'CAMP-004',
    empresaId: 'EMP-003',
    configPersonalizada: false,
  },
  {
    id: 'PART-C4-002',
    nome: 'Juliana Martins',
    email: 'bia.santos@email.com',
    cpf: '963.741.852-00',
    status: 'ativo',
    pontosDisponiveis: 1200,
    pontosAcumulados: 3500,
    nivel: 3,
    campanhaId: 'CAMP-004',
    empresaId: 'EMP-003',
    configPersonalizada: true,
    limiteResgateDiarioPersonalizado: 1000,
    prazoAprovacaoSaquePersonalizado: 6,
  },
];

export function getParticipantesPorEmail(email: string): ParticipanteCampanha[] {
  return participantesCampanhas.filter((p) => p.email.toLowerCase() === email.toLowerCase());
}

export function atualizarStatusParticipanteCampanha(
  id: string,
  novoStatus: ParticipanteCampanha['status']
): ParticipanteCampanha | undefined {
  const idx = participantesCampanhas.findIndex((p) => p.id === id);
  if (idx === -1) return undefined;
  participantesCampanhas[idx] = { ...participantesCampanhas[idx], status: novoStatus };
  return participantesCampanhas[idx];
}

export function toggleConfigPersonalizada(
  id: string,
  ativo: boolean
): ParticipanteCampanha | undefined {
  const idx = participantesCampanhas.findIndex((p) => p.id === id);
  if (idx === -1) return undefined;
  participantesCampanhas[idx] = { ...participantesCampanhas[idx], configPersonalizada: ativo };
  return participantesCampanhas[idx];
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'ativo': return 'bg-emerald-100 text-emerald-700';
    case 'pendente': return 'bg-amber-100 text-amber-700';
    case 'bloqueado': return 'bg-red-100 text-red-700';
    default: return 'bg-gray-100 text-gray-600';
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'ativo': return 'Ativo';
    case 'pendente': return 'Pendente';
    case 'bloqueado': return 'Bloqueado';
    default: return status;
  }
}